module.exports = "<div id=\"data-zoom-layer\">\r\n    <button class=\"unstyled close\">\r\n        <svg><use xlink:href=\"#fk-close\"></use></svg>\r\n    </button>\r\n    <button class=\"unstyled next\">\r\n        <svg><use xlink:href=\"#fk-caret-right\"></use></svg>\r\n    </button>\r\n    <button class=\"unstyled prev\">\r\n        <svg><use xlink:href=\"#fk-caret-left\"></use></svg>\r\n    </button>\r\n    <div class=\"img-container\">\r\n\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./fk.app/_src/components/data-zoom-layer.html
// module id = 44
// module chunks = 0